import {
  GET_TARGET_VALUE_DETAILS,
  GET_TARGET_VALUE_DETAILS_SUCCESS,
  GET_TARGET_VALUE_DETAILS_FAILURE,
  RESET_TARGET_VALUE_DETAILS,
  SAVE_DOCUMENT_OUTCOME,
} from "../Action/actionTypes";

interface TargetValueState {
  TargetValueData: {
    supplyDemand: string;
    precursorCostChange: number;
    stopLimit: number;
    goInPosition: number;
    rounds: number;
    NegotiationTarget: number;
    paymentTerms: string;
    incoTerms: string;
    localStock: string;
  };
  isLoaded: boolean;
  loading: boolean;
  error: string;
}

const initialState: TargetValueState = {
  TargetValueData: {
    supplyDemand: "",
    precursorCostChange: 0,
    stopLimit: 0,
    goInPosition: 0,
    rounds: 3,
    NegotiationTarget: 0,
    paymentTerms: "",
    incoTerms: "",
    localStock: "",
  },
  isLoaded: false,
  loading: false,
  error: "",
};

const TargetValueReducer = (
  state: TargetValueState = initialState,
  action: any
): TargetValueState => {
  switch (action.type) {
    case GET_TARGET_VALUE_DETAILS:
      return {
        ...state,
        loading: true,
      };

    case GET_TARGET_VALUE_DETAILS_SUCCESS:
      return {
        ...state,
        TargetValueData: action.payload,
        loading: false,
      };

    case GET_TARGET_VALUE_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case RESET_TARGET_VALUE_DETAILS:
      return {
        ...state,
        ...initialState,
      };
    case SAVE_DOCUMENT_OUTCOME:
      return {
        ...state,
        loading: true,
        isLoaded: true,
      };
    default:
      return state;
  }
};

export default TargetValueReducer;
